import React from 'react';
import { DEFAULT_CLUSTER_BY_GRID_SIZE } from '../constants';

// Обертки для асинхронной загрузки компонентов из JS API яндекс карт

/**
 * Обертка с React.lazy для загрузки react-компонентов из core JS API Яндекс.Карт
 * @param loadPromise Промис загрузки JS API
 */
export const loadReactComponent = (
  componentName:
    | 'YMap'
    | 'YMapDefaultSchemeLayer'
    | 'YMapDefaultFeaturesLayer'
    | 'YMapControls'
    | 'YMapMarker'
    | 'YMapControlButton'
    | 'YMapListener'
    | 'YMapLayer'
    | 'YMapFeatureDataSource',
  loadPromise: Promise<void>,
) =>
  React.lazy(async () => {
    await loadPromise;
    if (!window?.ymaps3Modules?.reactify)
      throw new Error('Cant find reactify module');
    const reactComponents = window.ymaps3Modules.reactify.module(ymaps3);
    return { default: reactComponents[componentName] };
  });

/**
 * Обертка с React.lazy для загрузки react-компонентов из модуля controls
 * @param loadPromise Промис загрузки JS API
 */
export const loadReactControlsComponent = (
  componentName: 'YMapGeolocationControl' | 'YMapZoomControl',
  loadPromise: Promise<void>,
) =>
  React.lazy(async () => {
    await loadPromise;
    if (!window?.ymaps3Modules?.reactify)
      throw new Error('Cant find reactify module');
    if (!window.ymaps3Modules.controls) {
      throw new Error('Cant find controls module');
    }
    const reactComponents = window.ymaps3Modules.reactify.module(
      window.ymaps3Modules.controls,
    );
    return { default: reactComponents[componentName] };
  });

/**
 * Обертка с React.lazy для загрузки react-компонентов из модуля markers
 * @param loadPromise Промис загрузки JS API
 */
export const loadReactMarkersComponent = (
  componentName: 'YMapDefaultMarker',
  loadPromise: Promise<void>,
) =>
  React.lazy(async () => {
    await loadPromise;
    if (!window?.ymaps3Modules?.reactify)
      throw new Error('Cant find reactify module');
    if (!window.ymaps3Modules.markers) {
      throw new Error('Cant find markers module');
    }
    const reactComponents = window.ymaps3Modules.reactify.module(
      window.ymaps3Modules.markers,
    );
    return { default: reactComponents[componentName] };
  });

/**
 * Обертка с React.lazy для загрузки react-компонентов из модуля clusterer
 * @param loadPromise Промис загрузки JS API
 */
export const loadClustererComponent = async (
  componentName: 'clusterByGrid',
  loadPromise: Promise<void>,
) => {
  await loadPromise;
  if (!window?.ymaps3Modules?.reactify)
    throw new Error('Cant find reactify module');
  if (!window.ymaps3Modules.clusterer) {
    throw new Error('Cant find clusterer module');
  }
  const components = window.ymaps3Modules.reactify.module(
    window.ymaps3Modules.clusterer,
  );

  return components[componentName];
};

/**
 * Обертка с React.lazy для загрузки компонента кластерера из clusterer
 * @param loadPromise Промис загрузки JS API
 */
export const loadReactClusterer = (loadPromise: Promise<void>) =>
  React.lazy(async () => {
    await loadPromise;
    if (!window?.ymaps3Modules?.reactify)
      throw new Error('Cant find reactify module');
    if (!window.ymaps3Modules.clusterer) {
      throw new Error('Cant find clusterer module');
    }
    const { YMapClusterer, clusterByGrid } =
      window.ymaps3Modules.reactify.module(window.ymaps3Modules.clusterer);
    return {
      // TODO: пропсы сейчас any, нужно разобраться, как их типизировать
      default: (props) => (
        <YMapClusterer
          method={clusterByGrid({
            gridSize: DEFAULT_CLUSTER_BY_GRID_SIZE,
          })}
          {...props}
        />
      ),
    };
  });
